export const recordCols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
    },
    {
        title: '录入日期',
        en_title: 'Date Encoded',
        ch_title: '录入日期',
        dataIndex: '录入日期',
        sorter: (a, b) => a['录入日期'].localeCompare(b['录入日期']),
    },
    {
        title: '开立票据份数',
        en_title: 'Number of Ticket Issued',
        ch_title: '开立票据份数',
        dataIndex: '开立票据份数',
    },
    {
        title: '票据总额',
        en_title: 'Ticket Total Amount',
        ch_title: '票据总额',
        dataIndex: '票据总额',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
    },
    {
        title: '志工人数',
        en_title: 'Number of Volunteers',
        ch_title: '志工人数',
        dataIndex: '志工人数',
    },
    {
        title: '票据状态',
        en_title: 'Ticket Status',
        ch_title: '票据状态',
        dataIndex: '票据状态',
    },
];
